var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.group.KodeNavn)?_c('p',[_vm._v(" "+_vm._s(_vm.$t("grpShortnameForSmsReg"))+": "),_c('strong',[_vm._v(_vm._s(_vm.group.KodeNavn.toUpperCase()))])]):_vm._e(),_c('p',[_c('SmsCodewordInstructions',{attrs:{"group-shortname":_vm.group.KodeNavn}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }